module.exports = __webpack_public_path__ + "static/img/江阴靖江3.1c0fe471.png";